const ro = {
    // generic
    "close": "Închide",
    "loading": "Se încarcă...",

    // OPS page
    "public.ops.404.title": "Ups, ceva nu a mers bine",
    "public.ops.404.subtitle": "Pagina pe care o cauți nu există sau nu a fost găsită",

    "public.ops.country_disabled.title": "Țară indisponibilă",
    "public.ops.country_disabled.subtitle": "Ne pare rău, dar programul nu este încă disponibil în țara ta.",

    "public.ops.country_mismatch.title": "Țară necorespunzătoare",
    "public.ops.country_mismatch.subtitle": "Țara asociată profilului tău de loialitate nu corespunde cu cea a contului tău B2C. Te rugăm să contactezi asistența pentru ajutor.",

    "public.ops.generic.title": "A apărut o eroare.",
    "public.ops.generic.subtitle": "Descoperă cerințele pentru a participa la programul de loialitate GEWISS Passion.",

    "public.ops.cta.label": "Înapoi",

    // welcome page
    "public.welcome.title": "Bine ai venit la",
    "public.welcome.subtitle": "Achiziționează produse GEWISS și acumulează puncte pentru a revendica premiile.",
    "public.welcome.cta.login": "Autentificare",
    "public.welcome.cta.signup": "Înregistrare",
    "public.welcome.cta.discover": "Află mai multe",

    "public.welcome.howto.title": "Cum funcționează GEWISS Passion?",
    "public.welcome.howto.lead": "Câștigarea premiilor este simplă și rapidă.",
    "public.welcome.howto.step1.title": "1. Cumpără produse GEWISS",
    "public.welcome.howto.step1.text": "Fiecare achiziție îți aduce puncte și te duce mai aproape de premiile tale preferate.",
    "public.welcome.howto.step2.title": "2. Încarcă factura",
    "public.welcome.howto.step2.text": "Fă o fotografie sau încarcă PDF-ul: verificare rapidă, punctele sunt actualizate în câteva zile și totul este gestionat din aplicație sau website.",
    "public.welcome.howto.step3.title": "3. Acceptă misiunile",
    "public.welcome.howto.step3.text": "Completează sondaje, urmărește videoclipuri de training și testează-ți cunoștințele cu întrebări: fiecare activitate este o oportunitate suplimentară de a câștiga puncte. Verifică constant aplicația pentru a rămâne la curent cu misiunile active.",
    "public.welcome.howto.step4.title": "4. Alege și revendică premiile",
    "public.welcome.howto.step4.text": "Ai atins obiectivul de puncte? Răsfoiește catalogul și revendică premiul oricând ești pregătit. Următorul pas depinde de tine.",

    // onboard
    "public.onboard.title": "Completează profilul tău de loialitate",
    "public.onboard.subtitle": "Verifică și completează datele companiei pentru a finaliza înregistrarea",
    "public.onboard.form.submit.label": "Înscrie-te în program",
    "public.onboard.form.submitting.label": "Se accesează programul ...",

    "public.onboard.form.labels.vat": "Cod CUI *",
    "public.onboard.form.labels.business_name": "Denumire socială *",
    "public.onboard.form.labels.business_email": "E-mail *",
    "public.onboard.form.descriptions.business_email":
        "Introdu adresa de e-mail a companiei. O vom folosi pentru a te informa despre aderarea ta la program.",

    "public.onboard.form.labels.t_and_c": "",
    "public.onboard.form.labels.t_and_c_text":
        "Declar că am luat la cunoștință <a href='https://www.gewiss.com/ro/ro/about-gewiss/privacy-policy' target='_blank'>Politica de confidențialitate</a> și accept <a href='https://cdn.jnext-it.jakala.cloud/IOJ3HsZEXv8qP/vmrMbpNNkTsPk/assets/docs/ro/Rules.pdf' target='_blank'>regulamentul</a>.",
    "public.onboard.form.labels.agree": "Confirm",
    "public.onboard.form.labels.decline": "Nu accept",

    "public.onboard.form.validation.vat_required": "Cod CUI obligatoriu",
    "public.onboard.form.validation.vat_too_short": "Cod CUI invalid",
    "public.onboard.form.validation.business_name_required": "Denumirea socială este obligatorie",
    "public.onboard.form.validation.business_name_too_short": "Denumirea socială este prea scurtă",
    "public.onboard.form.validation.business_email_required": "Email obligatoriu",
    "public.onboard.form.validation.business_email_invalid": "Email invalid",
    "public.onboard.form.validation.gdpr_required": "Acceptarea condițiilor este obligatorie",
    "public.onboard.form.validation.field_required": "Câmp obligatoriu",

    "public.onboard.form.feedback.vat_invalid.title": "Cod CUI invalid.",
    "public.onboard.form.feedback.vat_invalid.message": "Cod CUI invalid",
    "public.onboard.form.feedback.vat_invalid.label": "Închide",
    "public.onboard.form.feedback.vat_already_used.message": "Înregistrarea nu poate fi finalizată. Codul de TVA introdus este deja înregistrat.",

    "public.onboard.form.feedback.generic_error.title": "Eroare.",
    "public.onboard.form.feedback.generic_error.label": "Închide",
    "public.onboard.form.feedback.generic_error.message": "Te rugăm să încerci din nou.",

    // footer
    "public.footer.text":
        "Sediul social: Via Domenico Bosatelli, 1 - 24069 CENATE SOTTO BG - Italia - Cod fiscal, cod TVA și număr de înregistrare la Camera de Comerț Bergamo: 00385040167 - Copyright ©2026 - Capital social 60.010.000,00 EURO vărsat integral. Companie aflată sub conducerea și coordonarea Polifin S.p.A.",
    "public.footer.links.rules.label": "Regulament",
    "public.footer.links.rules.link": "IOJ3HsZEXv8qP/vmrMbpNNkTsPk/assets/docs/ro/Rules.pdf",
    "public.footer.links.privacy.label": "Politica de confidențialitate",
    "public.footer.links.privacy.link": "https://www.gewiss.com/ro/ro/about-gewiss/privacy-policy",
    "public.footer.links.cookie.label": "Cookie Policy",

    "footer:unsubscribe_program": "Dezabonare de la program",
    "unsubscribe:modal:title": "Confirmă dezabonarea",
    "unsubscribe:modal:text": "Ești pe cale să trimiți o cerere de dezabonare de la program.",
    "unsubscribe:modal:fineprint": "Cererea ta va fi procesată în termen de {{days}} zile lucrătoare.",
    "unsubscribe:modal:cta": "Confirmă dezabonarea",

    "unsubscribe:modal:loading:title": "Se trimite cererea",
    "unsubscribe:modal:loading:text": "Trimitem cererea ta de dezabonare.",

    "unsubscribe:modal:success:title": "Cerere trimisă",
    "unsubscribe:modal:success:text": "Cererea ta de dezabonare a fost trimisă cu succes.",
    "unsubscribe:modal:success:label": "Închide",

    "unsubscribe:modal:error:text": "A apărut o eroare la trimiterea cererii tale. Te rugăm să încerci din nou mai târziu.",

    // language picker
    "public.language.modal.title": "Alege limba",
    "public.language.open_picker": "Deschide selectorul de limbă",
    "public.language.current_prefix": "Sunteți în",
    "public.language.change_country": "Schimbă țara"
};

export default ro;